module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/bell-36a719811bb30c95a7386f47a3d8a54d.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/bell.svg
// module id = VoKK
// module chunks = 24